

























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ImageInfo from '@/views/AiiTasks/ImageInfo.vue'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import moment from 'moment'
import { uuid, dateFormat, throttle, download } from '@/utils/util'
import RelationOrders from '@/views/AiiTasks/RelationOrders.vue'
import Task from '@/web-task'
import Info from '@/views/AiiTasks/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import ImageItem from '@/views/AiiTasks/ImageItem.vue'
import ImageList from '@/views/AiiTasks/ImageList.vue'
import StaffInfo from '@/components/task/StaffInfo.vue'
import CancelApply from '@/components/task/CancelApply.vue'
import RecordSection from '@/components/task/RecordSection.vue'
import ImageUploads from '../other/ImagesUploads.vue'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
let viewer: any = ''
const recordOrder = ['3012', '3015', '3013', '3014', '3016', '3017']

@Component({
	components: {
		ImageInfo,
		RelationOrders,
		Info,
		InfoRow,
		ImageItem,
		ImageList,
		StaffInfo,
		CancelApply,
		RecordSection,
		ImageUploads,
	},
})
export default class AddTask extends Vue {
	@Prop()
	public task!: any

	@Prop()
	public injured!: any

	@Prop()
	public order!: any

	@Prop()
	public orderId!: string

	@Prop()
	private show!: any

	@Prop()
	private activeKey!: any

	private taskInfo: any = []
	private staffInfo: any = []
	private operatorCancelReasonInfo: any = false
	private operatorCancelHistoryInfo: any = false
	private caseDelayInfo: any = {}
	private injuredRecord: any = []
	private companyRecord: any = []
	private landlordRecord: any = []
	private committeeRecord: any = []
	private recordOrder: any = recordOrder

	private imageBlocks = [
		// {
		// 	name: '调查授权',
		// 	type: '0d01',
		// },
		{
			name: '被调查人身份证复印件（可选）',
			type: '0f01',
		},
		{
			name: '其他（可选）',
			type: '0900',
		},
	]
	private mediaMap: any = {}

	@Watch('task', { immediate: true })
	private onTaskChange() {
		this.taskInfo = this.task.getTaskInfo()
		this.taskInfo.span = {
			关节活动度复勘部位: 12,
			任务要求: 24,
			任务单证: 24,
		}
		this.staffInfo = this.task.getStaffInfo()

		this.operatorCancelReasonInfo = this.task.getOperatorCancelReasonInfo()

		this.operatorCancelHistoryInfo = this.task.getOperatorCancelHistoryInfo()

		this.injuredRecord = this.task.getInjuredRecord()
		this.caseDelayInfo = this.task.getCaseDelayInfo()
		if (this.task.isWorkInvestigate) {
			this.injuredRecord.span = {
				是否签字: 12,
			}
		} else {
			this.injuredRecord.span = {
				同住人与伤者关系: 12,
				详细地址: 18,
			}
		}
		if (this.task.isWorkInvestigate) {
			this.companyRecord = this.task.getCompanyRecord()
		} else {
			this.landlordRecord = this.task.getLandlordRecord()
			this.landlordRecord.span = {
				// 是否有同住人: 18,
				同住人与伤者关系: 12,
				伤者住房类型:
					this.injured.homeLandLordSurvey &&
					this.injured.homeLandLordSurvey.houseType === '2'
						? 6
						: 12,
			}
			this.committeeRecord = this.task.getCommitteeRecord()
		}
		if (this.order && this.order.imageList) {
			const mediaMap: any = {}
			this.order.imageList.forEach((imgObj: any) => {
				if (!mediaMap[imgObj.type]) {
					mediaMap[imgObj.type] = []
				}
				mediaMap[imgObj.type].push({ ...imgObj })
			})
			this.mediaMap = mediaMap
		}
	}

	private get supplyInfo() {
		if (['01', '02', '03'].includes(this.order.orderStatus)) {
			if (this.order.returnFlag === '1') {
				return '（待作业人员重新补录）'
			}
			return '（待作业人员补录）'
		}
		return ''
	}

	@Watch('activeKey')
	private onTabsChange() {
		window.scrollTo(0, 0)
	}

	private zeroUnit(val: any, unit: string = '元') {
		if (val === 0 || val) {
			return val + unit
		} else {
			return
		}
	}

	private dateFormat(start: any, end: any) {
		return dateFormat(start, end)
	}
}
